import { useState } from 'react'
import styles from './ApprovalSettingsPage.module.css'
import Modal from 'react-modal';
import { useQuery, useMutation } from '@apollo/client';
import { CHANGE_APPROVAL_TIER_THRESHOLD, GET_ALL_TIERS, DELETE_APPROVAL_TIER, ADD_APPROVAL_TIER } from '../../services/graphql';


function ApprovalSettingsPage() {
    const [tiers, setTiers] = useState([]);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editTier, setEditTier] = useState();
    const [editThresholdAmount, setEditThresholdAmount] = useState();
    const [newThreshold, setNewThreshold] = useState();

    const customModalStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'var(--theme-bg-elevated)',
            color: 'var(--theme-text)',
        },
        overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
        },
    };

    useQuery(GET_ALL_TIERS, {
    onCompleted(result) {
        //console.log("RAW QUERY RESULT:", result);
        const newData = result.getAllTiers.body.map((item) => ({
        id: Number(item.tierNumber),
        approvalTier: Number(item.tierNumber),
        threshold: isNaN(Number(item.threshold)) ? '-' : Number(item.threshold),
        }));

        newData.sort((a, b) => a.approvalTier - b.approvalTier);
        setTiers(newData);
    },
    onError(error) {
        console.error(error);
        alert('Unable to load tiers.');
    },
    });

    const [editThreshold] = useMutation(CHANGE_APPROVAL_TIER_THRESHOLD, {
        onCompleted(data) {
            if (data.changeApproverTierThreshold.status.statusCode == '200') reloadPage();
            else alert('Unable to edit threshold.');
        },
        onError() {
            alert('Unable to edit threshold.');
        }
    });

    const [deleteThreshold] = useMutation(DELETE_APPROVAL_TIER, {
        onCompleted(data) {
            if (data.deleteApproverTier.status.statusCode == '200') reloadPage();
            else alert('Unable to delete tier.');
        },
        onError() {
            alert('Unable to delete tier. Make sure the tier has no approval users.');
        }
    });

    const [addNewTier] = useMutation(ADD_APPROVAL_TIER, {
        onCompleted(data) {
            if (data.addApproverTier.status.statusCode == '200') reloadPage();
            else alert('Unable to add new tier.');
        },
        onError() {
            alert('Unable to add new tier.');
        }
    });

    const handleDelete = (id) => {
        deleteThreshold({
            variables: {
                tier: id,
            }
        })
    };

    const handleEdit = (id) => {
        console.log(id);
        setIsEditModalOpen(true);
        setEditTier(id);
    };

    const reloadPage = () => {
        window.location.reload();
    };


    const handleChangeEditThreshold = (event) => {
        setEditThresholdAmount(parseInt(event.target.value));
    };

    const handleChangeNewThreshold = (event) => {
        setNewThreshold(parseInt(event.target.value));
    };

    const saveEditThreshold = () => {
        const min = editTier >= 2 ? tiers[editTier - 2].threshold : 0;
        const max = tiers[editTier].threshold == '-' ? Infinity : tiers[editTier].threshold;
        const validEditThreshold = editThresholdAmount > min && editThresholdAmount < max;

        if (validEditThreshold) {
            editThreshold({
                variables: {
                    tier: editTier,
                    newThreshold: editThresholdAmount,
                    oldThreshold: tiers[editTier - 1].threshold,
                }
            })
        } else {
            alert(`Invalid threshold amount. Ensure the amount is between ${min} and ${max}`);
        }
    };

    const closeModal = () => {
        setIsAddModalOpen(false);
        setIsEditModalOpen(false);
    }

    const saveNewTier = () => {
        addNewTier({
            variables: {
                threshold: newThreshold,
            }
        });
    }

    return (
        <div className={styles.pageContainer}>
            <h2 className={styles.title}>Approval Settings</h2>
            <button onClick={() => setIsAddModalOpen(true)} className={styles.addLevelButton}>+ Add Approval Level</button>
            <table className={styles.tiertable}>
                <thead>
                    <tr>
                        <th className={styles.column}>Approval Tier</th>
                        <th className={styles.column}>Threshold ($)</th>
                        <th className={styles.column}></th>
                        <th className={styles.column}></th>
                    </tr>
                </thead>
                <tbody>
                    {tiers.map(({ id, approvalTier, threshold }) => (
                        <tr key={id}>
                            <td>{approvalTier}</td>
                            <td>{threshold}</td>
                            <td>{approvalTier !== tiers.length && <button className={styles.editButton} onClick={() => handleEdit(id)}>Edit</button>}</td>
                            <td>{approvalTier !== tiers.length && <button className={styles.deleteButton} onClick={() => handleDelete(id)}>Delete</button>}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <Modal
                isOpen={isEditModalOpen}
                onRequestClose={closeModal}
                style={customModalStyles}
                contentLabel="Submission Result"
            >
                <button className={styles.closeButton} onClick={closeModal}>
                    <span className={styles.closeIcon}>x</span>
                </button>
                <h2>Edit Approval Level {editTier}</h2>
                <label htmlFor="threshold">Enter New Threshold:</label>
                <input
                    type="number"
                    className={styles.inputValue}
                    onChange={handleChangeEditThreshold}
                />
                <button className={styles.saveButton} onClick={saveEditThreshold}>Save</button>
            </Modal>
            <Modal
                isOpen={isAddModalOpen}
                onRequestClose={closeModal}
                style={customModalStyles}
                contentLabel="Submission Result"
            >
                <button className={styles.closeButton} onClick={closeModal}>
                    <span className={styles.closeIcon}>x</span>
                </button>
                <h2>Add New Approval Level</h2>
                <label htmlFor="threshold">Enter Threshold:</label>
                <input
                    type="number"
                    className={styles.inputValue}
                    onChange={handleChangeNewThreshold}
                />
                <button className={styles.saveButton} onClick={saveNewTier}>Save</button>
            </Modal>
        </div>
    )
}

export default ApprovalSettingsPage;